import { ThemeTypes } from '@talos/kyoko';
import type { ShowcaseStep } from './types';

export function getShowcaseStepImageUrl(step: ShowcaseStep, themeType: ThemeTypes): string | undefined {
  return (themeType === ThemeTypes.dark ? step.imageDark : step.imageLight) ?? step.imageDark;
}

/** Collect unique image URLs for the active theme from showcase steps. */
export function getShowcaseImageUrls(steps: ShowcaseStep[], themeType: ThemeTypes): string[] {
  const urls = new Set<string>();

  for (const step of steps) {
    const url = getShowcaseStepImageUrl(step, themeType);
    if (url) {
      urls.add(url);
    }
  }

  return [...urls];
}

/**
 * Prefetch showcase step images for the active theme so later steps are ready
 * without waiting until each step renders.
 */
export function prefetchShowcaseImages(steps: ShowcaseStep[], themeType: ThemeTypes): void {
  if (typeof Image === 'undefined') {
    return;
  }

  for (const url of getShowcaseImageUrls(steps, themeType)) {
    const image = new Image();
    image.src = url;
  }
}
